import React, { Fragment } from "react";
import TransitionOnLoad from "Components/TransitionOnLoad";
import { Card, CardBody, Col, Row } from "reactstrap";
import PageHeading from "Layout/AppMain/PageHeading";
import Loader from 'react-loaders';
import { usePowerBiLink } from "Api/Coordinator/Beheer/Reporting";

const Reporting = () => {

const {
    data: powerBiResponse,
    isLoading
} = usePowerBiLink();

const powerBiLink =
    powerBiResponse?.status
        ? powerBiResponse.data
        : "";

    return (
        <Fragment>
            <PageHeading />
           <TransitionOnLoad>
                    <Row className="mb-5">
                        <Col sm={12}>
                            <div className="row">
                                <div className="col">
                                    <Card className="main-card mb-3">
                                        <CardBody className="p-5">
                                            {isLoading ? (
                                                <Loader
                                                    type="ball-grid-pulse"
                                                    className="mt-3 d-flex mx-auto justify-content-center"
                                                />
                                            ) : (
                                                powerBiLink ? (
                                                    /^(https?:\/\/)?([\w-]+\.)+[\w-]+(\/[\w-./?%&=]*)?$/.test(powerBiLink) ? (
                                                        <iframe
                                                            width="100%"
                                                            height="676"
                                                            title="powerbi"
                                                            src={powerBiLink}
                                                            allowFullScreen={true}
                                                        ></iframe>
                                                    ) : (
                                                        <p className="text-center">Invalid Link</p>
                                                    )
                                                ) : (
                                                    <p className="text-center">No Link Added</p>
                                                )
                                            )}
                                        </CardBody>
                                    </Card>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </TransitionOnLoad>
        </Fragment>
    )
}

export default Reporting